import {useContext, useEffect, useCallback, useState} from 'react';
import {UserContext} from "../common/UserContext";
import {ContentContext} from "../common/ContentContext";
import axios from "../common/axios";
import {TemplateContext} from "../common/TemplateContext";
import useCurrentShortcut from "./useCurrentShortcut";
import {ShortcutContext} from "../common/ShortcutContext";

export default function useCurrentConcept() {
    const {user, setUser, loadUser} = useContext(UserContext);
    const {content, loadContent, setContentLoading, setMediaLocation} = useContext(ContentContext);
    const {shortcutMap} = useContext(ShortcutContext);
    const {singlePage, setShortcut} = useContext(TemplateContext);

    const lessonUrl = '/lessonSection/lesson.action';
    const contentUrl = '/administration/syllabus/manageSyllabus.action';

    const defaultConceptShortcut = {
        name: 'Lesson',
        titleComponent:  'LessonTitle',
        bodyComponent:  'LessonContent',
        url: lessonUrl,
        shortcutLocation: 'LESSON',
        cmsMode: false
    };

    const defaultContentShortcut = {
        name: 'Content',
        bodyComponent: 'AdminCMSContent',
        url: contentUrl,
        shortcutLocation: 'CMS',
        cmsMode: true
    }

    const loadCurrentConcept = (currentConceptId, urlHash) => {
        if(currentConceptId === undefined) {
            return undefined;
        }

        const lessonShortcut = shortcutMap.get(lessonUrl);
        const contentShortcut = shortcutMap.get(contentUrl);

        setContentLoading(true);
        axios.get('/web/ui/content/concept/changeCurrentConcept', {params: {conceptId: currentConceptId}})
            .then(response => {
                loadContent();
                setMediaLocation('CONCEPT');

                const serverBuildVersion = response.headers['x-edjin-version'];
                if(serverBuildVersion && serverBuildVersion != 'default' && window.buildVersion && window.buildVersion != 'default' && window.buildVersion != serverBuildVersion) {
                    console.log('build version does not match', serverBuildVersion, window.buildVersion);
                    //window.location.href = lessonUrl;
                    //return;
                }

                if(user.cmsMode && contentShortcut) {
                    // setShortcut(contentShortcut);
                    //window.history.replaceState({}, '', contentShortcut.url);
                } else if(lessonShortcut) {
                    setShortcut(lessonShortcut);
                    window.history.replaceState({}, '', lessonShortcut.url + (urlHash ? '#' + urlHash: ''));
                } else {
                    setShortcut(defaultConceptShortcut);
                    window.history.replaceState({}, '', defaultConceptShortcut.url);
                }
            }).catch(e => {
                setContentLoading(false);
                console.error('Error changing concept', e);
            });
    };

    const loadPreviousConcept = (currentConceptId) => {
        if (currentConceptId == undefined) {
            return;
        }

        const lessonShortcut = shortcutMap.get(lessonUrl);
        const contentShortcut = shortcutMap.get(contentUrl);

        setContentLoading(true);
        axios.get('/web/ui/content/concept/changeToPreviousConcept', {params: {conceptId: currentConceptId}})
            .then(response => {
                if(response.data) {
                    //loadUser();
                    loadContent();
                    setMediaLocation('CONCEPT');

                    if(user.cmsMode && contentShortcut) {
                        // setShortcut(contentShortcut);
                    } else if(lessonShortcut) {
                        setShortcut(lessonShortcut);
                    } else {
                        setShortcut(defaultConceptShortcut);
                    }
                    window.history.pushState({}, '', '#');
                }
                setContentLoading(false);
            }).catch(e => {
                console.error('Error changing concept', e);
                setContentLoading(false);
            });
    };

    const loadNextConcept = (currentConceptId) => {
        if (currentConceptId == undefined) {
            return;
        }

        const lessonShortcut = shortcutMap.get(lessonUrl);
        const contentShortcut = shortcutMap.get(contentUrl);

        setContentLoading(true);
        axios.get('/web/ui/content/concept/changeToNextConcept', {params: {conceptId: currentConceptId}})
            .then(response => {
                if(response.data) {
                    //loadUser();
                    loadContent();
                    setMediaLocation('CONCEPT');

                    if(user.cmsMode && contentShortcut) {
                        // setShortcut(contentShortcut);
                    } else if(lessonShortcut) {
                        setShortcut(lessonShortcut);
                    } else {
                        setShortcut(defaultConceptShortcut);
                    }
                    window.history.pushState({}, '', '#');
                }
                setContentLoading(false);
            }).catch(e => {
                console.error('Error changing concept', e);
                setContentLoading(false);
            });
    };

    const exitSupplementaryConcept = () => {
        setContentLoading(true);
        axios.get('/lessonSection/endSupplementaryLesson.action')
            .then(response => {
                if(response.data.success && response.data.concept) {

                }
            }).catch(function (e) {
                console.error('Error loading content', e);
                setContentLoading(false);
                if (typeof newrelic !== 'undefined') {
                    newrelic.noticeError('Error supplementary lesson error: ' + e);
                };
            });
    };

    if(globalReactFunctions !== undefined) {
        globalReactFunctions.loadCurrentConcept = loadCurrentConcept;
        globalReactFunctions.loadPreviousConcept = loadPreviousConcept;
        globalReactFunctions.loadNextConcept = loadNextConcept;
        globalReactFunctions.exitSupplementaryConcept = exitSupplementaryConcept;
    }

    return {loadCurrentConcept,loadPreviousConcept,loadNextConcept};
}
